import { InjectionToken } from '@angular/core';

import { BaseAnalyticsConfig } from '@libs/src/analytics/analytics.module';

export const ANALYTICS_CONFIG_TOKEN = new InjectionToken<BaseAnalyticsConfig>(
  'ANALYTICS_INJECT_TOKEN',
);
